<template>
    <div class="col-lg-6  mb-3" :class="{'chart-loading': loading}">
        <h3 class="mb-3"><b>Theo Dõi Kết Quả Đánh Giá</b></h3>
        <div class="dashboard-box mb-3">
            <div>
                Đã hoàn thành <span class="success">{{ result.success }}</span><span class="total">/{{ result.total }}</span> công việc
            </div>
        </div>
        <Chart type="bar" :data="resultData" :options="resultOptions" :key="componentKey"/>
    </div>
</template>

<script>
import Chart from '@/components/Chart.vue';
export default {
    name: "chartResult",
    props: {
        evaluation_form: Object,
        loading: Boolean
    },
    components: {
        Chart
    },
    watch: {
        "$props.evaluation_form"() {
            this.resultData.labels = this.evaluation_form?.dataChart?.label ?? [];
            this.resultData.datasets[0].data = this.evaluation_form?.dataChart?.all ?? [];
            this.resultData.datasets[1].data = this.evaluation_form?.dataChart?.success ?? [];
            this.result.total = this.evaluation_form?.countAll ?? 0;
            this.result.success = this.evaluation_form?.countSuccess ?? 0;
            this.componentKey++;
        }
    },
    data() {
        return {
            componentKey: 0,
            result: {
                total: 0,
                success: 0
            },
            resultOptions: {
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            color: '#495057'
                        },
                        position: 'bottom'
                    },
                    datalabels: {
                        color: '#000000',
                        anchor: 'end',
                        align: 'end',
                        clamp: true,
                        formatter: function(value) {
                            return String(value).replace(/(.)(?=(\d{3})+$)/g, "$1,");
                        }
                    }
                }
            },
            resultData: {
                // labels: [1,2,3,4,5,6,7,8,9,10,11,12],
                datasets: [
                    {
                        label: 'Kế hoạch',
                        backgroundColor: '#146082',
                        pointStyle: 'rect',
                        maxBarThickness: 16,
                        // data: [4,5,7,9,11,15,20,21,23,25,30,35]
                    },
                    {
                        label: 'Thực hiện',
                        backgroundColor: '#E97131',
                        pointStyle: 'rect',
                        maxBarThickness: 16,
                        // data: [2,5,5,8,10]
                    }
                ]
            },
        }
    }
}
</script>